document.addEventListener('DOMContentLoaded', function () {
    const flavorRadios = document.querySelectorAll('input[name="Flavor-1"]'); // Flavor radio buttons
    const packSizeRadios = document.querySelectorAll('input[name="Pack Size-2"]'); // Pack Size radio buttons
    const variantsToHide = [
        { flavor: 'Double Choc', packSize: '1 Pack' }, // Example variant to hide based on the combination
        { flavor: 'Variety Pack', packSize: '5 Pack' } // Example variant to hide based on the combination
    ];

    // Function to hide or show variants based on selected options
    function hideVariants() {
        const selectedFlavor = document.querySelector('input[name="Flavor-1"]:checked').value;
        const selectedPackSize = document.querySelector('input[name="Pack Size-2"]:checked').value;

        variantsToHide.forEach(variant => {
            const variantElement = document.querySelector(`.variant[data-flavor="${variant.flavor}"][data-pack-size="${variant.packSize}"]`);
            if (variantElement) {
                // Hide the variant if the selected combination matches the one in variantsToHide
                if (selectedFlavor === variant.flavor && selectedPackSize === variant.packSize) {
                    variantElement.style.display = 'none';
                } else {
                    variantElement.style.display = ''; // Show the variant otherwise
                }
            }
        });
    }

    // Attach event listeners to radio buttons
    flavorRadios.forEach(radio => {
        radio.addEventListener('change', hideVariants);
    });

    packSizeRadios.forEach(radio => {
        radio.addEventListener('change', hideVariants);
    });

    // Initial run to hide/show variants when page loads
    hideVariants();
});
